import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { initializeApp, getApps } from 'firebase/app';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import logo from '../logo.png';

const firebaseConfig = {
  apiKey: "AIzaSyBsqlPoTKpDHHGcBHeuM-b5iHNi7IEtoU8",
  authDomain: "the-ourstory-app.firebaseapp.com",
  projectId: "the-ourstory-app",
  storageBucket: "the-ourstory-app.firebasestorage.app",
  messagingSenderId: "246953432041",
  appId: "1:246953432041:web:0f6289e63d901d540b3178"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
const db = getFirestore(app);

export default function PromptShare() {
  const { promptId } = useParams();
  const [prompt, setPrompt] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchPrompt() {
      try {
        const snap = await getDoc(doc(db, 'prompts', promptId));
        if (snap.exists() && snap.data().status !== 'locked') setPrompt(snap.data());
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    fetchPrompt();
  }, [promptId]);

  useEffect(() => {
    if (prompt) {
      document.title = 'OurStory — ' + prompt.text;
    }
  }, [prompt]);

  const brand = prompt?.brand || null;

  return (
    <div style={brand ? { ...styles.page, backgroundColor: brand.bg, color: brand.text } : styles.page}>
      <nav style={styles.nav}>
        <a href="/" style={brand ? { ...styles.navLogo, color: brand.text } : styles.navLogo}>OurStory</a>
      </nav>
      <div style={styles.container}>
        <a href="https://theourstoryapp.com">
          {brand?.imageUrl
            ? <img src={brand.imageUrl} alt={brand.name || ''} style={styles.brandImage} />
            : <img src={logo} alt="OurStory" style={styles.logo} />}
        </a>
        {brand ? (
          <div style={{ ...styles.brandTitle, color: brand.text }}>
            {brand.title ? brand.title + ' · ' : ''}{brand.name}
          </div>
        ) : null}
        <div style={brand ? { ...styles.card, backgroundColor: brand.text + '14' } : styles.card}>
          <div style={brand ? { ...styles.promptLabel, color: brand.text, opacity: 0.75 } : styles.promptLabel}>
{brand ? `A PROMPT FROM ${(brand.name || '').toUpperCase()}` : prompt ? `PROMPT FROM ${(prompt.scheduledDate
  ? new Date(prompt.scheduledDate + 'T00:00:00')
  : new Date(prompt.createdAt?.seconds ? prompt.createdAt.seconds * 1000 : prompt.createdAt)
).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).toUpperCase()}` : 'PROMPT'}
          </div>
          {loading ? (
            <div style={styles.loading}>Loading prompt...</div>
          ) : prompt ? (
            <p style={brand ? { ...styles.promptText, color: brand.text } : styles.promptText}>"{prompt.text}"</p>
          ) : (
            <p style={styles.promptText}>This prompt is no longer available.</p>
          )}
        </div>
        <p style={brand ? { ...styles.cta, color: brand.text, opacity: 0.85 } : styles.cta}>Share your story on OurStory</p>
        <div style={styles.btns}>
          <a href="https://apps.apple.com/us/app/the-ourstory-app/id6759184164" style={styles.storeBtn}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#1D492F">
              <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
            </svg>
            <span>App Store</span>
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.brianna.ourstory" style={styles.storeBtn}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="#1D492F">
              <path d="M3 20.5v-17c0-.83.94-1.3 1.6-.8l14 8.5c.6.36.6 1.24 0 1.6l-14 8.5c-.66.5-1.6.03-1.6-.8z"/>
            </svg>
            <span>Google Play</span>
          </a>
        </div>
        <p style={brand ? { ...styles.footer, color: brand.text, opacity: 0.5 } : styles.footer}>© 2026 OurStory. All rights reserved.</p>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', backgroundColor: '#1D492F', fontFamily: 'sans-serif', color: 'white' },
  nav: { padding: '16px 24px', borderBottom: '1px solid rgba(255,255,255,0.08)' },
  navLogo: { color: 'white', textDecoration: 'none', fontSize: '20px', fontFamily: 'Merriweather, serif', fontWeight: '700' },
  container: { maxWidth: '480px', margin: '0 auto', padding: '40px 24px', textAlign: 'center' },
  logo: { width: '64px', height: '64px', marginBottom: '24px' },
  brandImage: { width: '160px', height: '160px', borderRadius: '14px', objectFit: 'cover', marginBottom: '12px' },
  brandTitle: { fontFamily: 'Merriweather, serif', fontWeight: '700', fontSize: '18px', marginBottom: '24px' },
  card: { backgroundColor: '#163824', borderRadius: '20px', padding: '28px', marginBottom: '24px' },
  promptLabel: { fontSize: '10px', letterSpacing: '2px', color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', marginBottom: '12px' },
  promptText: { fontSize: '18px', lineHeight: '1.6', color: 'white', fontStyle: 'italic', margin: 0 },
  loading: { color: 'rgba(255,255,255,0.4)', fontSize: '14px' },
  cta: { fontSize: '14px', color: 'rgba(255,255,255,0.6)', marginBottom: '24px' },
  btns: { display: 'flex', gap: '12px', justifyContent: 'center', marginBottom: '40px' },
  storeBtn: { display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'white', borderRadius: '12px', padding: '12px 20px', textDecoration: 'none', color: '#1D492F', fontSize: '14px', fontWeight: 'bold' },
  footer: { fontSize: '11px', color: 'rgba(255,255,255,0.2)' },
};
